import { useEffect } from "react";
import { useQuery } from "react-query";
import { api } from "services/api";
import { WhatsAppNumber } from "types/WhatsAppNumber";
import { handleRequestError } from "utils/Request";

export async function fetchCallClientNumbers(): Promise<WhatsAppNumber[]> {
  const { data } = await api.get('/messages/call-client-numbers');
  return data;
}

export function useCallClientNumbers() {
  const query = useQuery('call-client-numbers', () => fetchCallClientNumbers());

  useEffect(() => {
    if (!query.isError) return;
    handleRequestError(query.error, 'Ocorreu um erro ao listar os números disponíveis. Por favor, tente novamente!');
  }, [query.isError, query.error]);

  return query;
}
